import React, { Component ,useRef, createRef} from 'react'
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import {BrowserRouter as Router,Link, Redirect, Route } from 'react-router-dom'
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import SpecialCaseCreation from './SpecialCaseCreation';
import myToast from '../Utils/MyToast';
import SelectClass from '../ChildComponent/SelectClass';
import BackButton from '../ChildComponent/BackButton';
export default class SpecialCaseStudent extends Component {
  constructor(props) {
    super(props)        
   
    const token=localStorage.getItem("token");
    let loggedIn=true;
    if(token==null){
      loggedIn=false;
    }
  
    this.state={  
        isOpen: false, 
        loggedIn:true,
        Loading:false,
        LoadingStudent:false,
        mSpecialCaseStudent:[],
        CLASS_ID:'',
        SECTION_ID:'',
        SESSION_ID:'',
        SESSION_NAME:'',
        SELECTED_CLASS_POSITION:0,
        feeCollectionStatus: {}, // Store fee collection status for each student
        editingFee: null, // Track which fee is being edited: { student_id, fee_id, originalValue }
        editedFeeValue: '', // Current edited value
        savingFee: false, // Track if fee is being saved
    }
    this.CallBackClassSelect= this.CallBackClassSelect.bind(this);
    this.handleEdit= this.handleEdit.bind(this);
    this.handleDelete= this.handleDelete.bind(this);
    this.handleCancelEdit= this.handleCancelEdit.bind(this);
    this.handleSaveFee= this.handleSaveFee.bind(this);
     
  }

  CallBackClassSelect = (class_id,section_id,session_id,selected_position,class_name,section_name,session_name) => {
  
    this.state.CLASS_ID=class_id;
    this.state.SECTION_ID=section_id;
    this.state.SESSION_ID=session_id;
    this.state.SELECTED_CLASS_POSITION=selected_position;
    //alert("Back"+class_id+"/"+section_id+"/"+session_id);
    this.getSpecialCaseStudent();
  }
  componentDidMount() {
  //  window.scrollTo(0, 0)
     
  }     
  getSpecialCaseStudent(){

  this.state.mSpecialCaseStudent=[];
    
    this.setState({
      LoadingStudent:true
    })
    
    const SCHOOL_CODE=SessionManager.getSchoolCode();
    const FUNCTION_NAME='getSpecialCaseStudentsBatch.php'
    URL=process.env.REACT_APP_SERVER_NAME+process.env.REACT_APP_TARGET_DIR+FUNCTION_NAME
    console.log("URL>>>>>", URL);
    
    const params = {
      session_id:this.state.SESSION_ID,
      class_id:this.state.CLASS_ID,
      section_id:this.state.SECTION_ID,
      school_code:SCHOOL_CODE,
      limit: 500, // Maximum limit for batch endpoint
      offset: 0
    };
    console.log("Params>>>>>", params);
    
    // Log full URL with query parameters
    const queryString = new URLSearchParams(params).toString();
    const fullURL = URL + '?' + queryString;
    console.log("Full URL>>>>>", fullURL);
    
   axios.get(URL,{
  params: params
}).then(res => res.data)
.then((response) => {
 
  this.setState({ 
    LoadingStudent:false
   })
    //console.log("Response2>>>>>"+response);
    let api_status=response.api_status;
    //alert(api_status);  
    if(api_status=="OK")
    {
      console.log("Batch Response - Total Count:", response.total_count);
      console.log("Batch Response - Limit:", response.limit);
      console.log("Batch Response - Offset:", response.offset);
      console.log("Batch Response - Students Count:", response.data ? response.data.length : 0);
      
      this.setState({            
        mSpecialCaseStudent:response.data,
      })
      // Fee collection status is already included in batch response (fee-wise)
      if(response.data && response.data.length > 0) {
        const feeStatusUpdates = {};
        response.data.forEach((student) => {
          const key = `${student.student_id}_${student.class_id}`;
          // Overall fee collected status (if any fee is collected)
          feeStatusUpdates[key] = student.fee_collected === true;
          
          // Fee-wise collection status is in each fee_detail
          // This allows checking individual fees if needed
          if(student.fee_details && Array.isArray(student.fee_details)) {
            student.fee_details.forEach((fee) => {
              const feeKey = `${student.student_id}_${student.class_id}_${fee.fee_id}`;
              feeStatusUpdates[feeKey] = fee.fee_collected === true;
            });
          }
        });
        
        this.setState(prevState => ({
          feeCollectionStatus: {
            ...prevState.feeCollectionStatus,
            ...feeStatusUpdates
          }
        }));
      }
           
    }
    else{
      let api_remark=response.api_remark;
      myToast.notify_warning(api_remark);
    }
 }).catch((error)=>{
  this.setState({ 
    Loading:false
   })
  console.log("error>>>>>"+error);
  });
}

  // Removed checkFeeCollectionStatusBatch - fee collection status is now included in getSpecialCaseStudentsBatch response

  handleEdit(student, fee) {
    const feeKey = `${student.student_id}_${student.class_id}_${fee.fee_id}`;
    const feeCollected = this.state.feeCollectionStatus[feeKey];
    
    if (feeCollected) {
      myToast.notify_warning(`Cannot edit: Fee collection or settlement is already done for ${fee.fee_name}.`);
      return;
    }
    
    // Get current fee value
    const currentValue = fee.student_fee !== undefined && fee.student_fee !== null 
      ? parseFloat(fee.student_fee) || 0
      : (fee.special_value !== undefined && fee.special_value !== null 
        ? parseFloat(fee.special_value) || 0
        : (fee.fee_value !== undefined && fee.fee_value !== null ? parseFloat(fee.fee_value) || 0 : 0));
    
    // Set editing state
    this.setState({
      editingFee: {
        student_id: student.student_id,
        fee_id: fee.fee_id,
        originalValue: currentValue
      },
      editedFeeValue: currentValue
    });
  }

  handleCancelEdit = () => {
    this.setState({
      editingFee: null,
      editedFeeValue: ''
    });
  }

  handleSaveFee = (student, fee) => {
    const { editingFee, editedFeeValue } = this.state;
    
    if (!editingFee || editingFee.student_id !== student.student_id || editingFee.fee_id !== fee.fee_id) {
      return;
    }
    
    // Validate value
    const newValue = parseFloat(editedFeeValue);
    if (isNaN(newValue) || newValue < 0) {
      myToast.notify_warning("Please enter a valid fee amount");
      return;
    }
    
    // Check if value changed
    if (newValue === editingFee.originalValue) {
      myToast.notify_warning("No changes to save");
      this.handleCancelEdit();
      return;
    }
    
    // Check if fee is collected
    const feeKey = `${student.student_id}_${student.class_id}_${fee.fee_id}`;
    const feeCollected = this.state.feeCollectionStatus[feeKey];
    
    if (feeCollected) {
      myToast.notify_warning(`Cannot save: Fee collection or settlement is already done for ${fee.fee_name}.`);
      return;
    }
    
    this.setState({ savingFee: true });
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mStaffData = SessionManager.getStaffDetails();
    const STAFF_ID = mStaffData.staff_id;
    const FUNCTION_NAME = 'updateSpecialFee.php';
    const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
    
    const params = {
      staff_id: STAFF_ID,
      student_id: student.student_id,
      session_id: this.state.SESSION_ID,
      class_id: student.class_id,
      section_id: this.state.SECTION_ID,
      fee_id: fee.fee_id,
      fee_value: newValue,
      fee_value_old: editingFee.originalValue,
      school_code: SCHOOL_CODE,
    };
    
    axios.get(URL, { params })
    .then(res => res.data)
    .then((response) => {
      this.setState({ savingFee: false });
      
      if (response.api_status === "OK") {
        myToast.notify_success(`Fee "${fee.fee_name}" updated successfully`);
        this.handleCancelEdit();
        // Refresh the student list
        this.getSpecialCaseStudent();
      } else {
        myToast.notify_error(response.api_remark || "Failed to update fee");
      }
    })
    .catch((error) => {
      this.setState({ savingFee: false });
      console.error("Error updating fee:", error);
      myToast.notify_error("Error updating fee. Please try again.");
    });
  }

  handleDelete(student, fee) {
    const feeKey = `${student.student_id}_${student.class_id}_${fee.fee_id}`;
    const feeCollected = this.state.feeCollectionStatus[feeKey];
    
    if (feeCollected) {
      myToast.notify_warning(`Cannot delete: Fee collection or settlement is already done for ${fee.fee_name}.`);
      return;
    }
    
    if (window.confirm(`Are you sure you want to delete special case fee "${fee.fee_name}" for ${student.stu_name}?`)) {
      this.deleteSpecialCaseFee(student, fee);
    }
  }

  deleteSpecialCaseFee(student, fee) {
    this.setState({ Loading: true });
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = 'updateSpecialCaseStatus.php';
    const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
    
    axios.post(URL, {
      student_id: student.student_id,
      class_id: student.class_id,
      section_id: this.state.SECTION_ID,
      session_id: this.state.SESSION_ID,
      school_code: SCHOOL_CODE,
      fee_id: fee.fee_id,
      status: 'InActive'
    }).then(res => res.data)
    .then((response) => {
      this.setState({ Loading: false });
      
      if (response.api_status === "OK") {
        myToast.notify_success(`Special case fee "${fee.fee_name}" deleted successfully.`);
        this.getSpecialCaseStudent(); // Refresh the list
      } else {
        myToast.notify_error(response.api_remark || "Failed to delete special case fee.");
      }
    }).catch((error) => {
      this.setState({ Loading: false });
      console.log("Error deleting special case fee:", error);
      myToast.notify_error("Error deleting special case fee. Please try again.");
    });
  }

  render() {
    if(this.state.loggedIn==false)
    {
    return <Redirect to='/Login'/>;
    }
    if(this.state.Loading)
    {
         return <MyLoader/>
    }
    else{       
     
        return (
          
        <Router>
        <switch>
          <Route path={'/AdminMain/SpecialCaseStudent'}  exact render={
            ()=>{
          return(  
              <div className="content" style={{background:'#f5f7fa', minHeight:'100vh'}}>
          <div className="content-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li><i className="fa fa-home text-white" aria-hidden="true" /><a href="#"> Special Case Student </a></li>
              </ul>
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <BackButton />
            </div>
          </div>
          <div style={{
            background: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            margin: '12px',
            padding: '16px',
            minHeight: 'calc(100vh - 120px)',
            border: '1px solid #f0f0f0'
          }}>


          {this.state.Loading ? <MyLoader/> : 
         <div>
           
          <SelectClass action={this.CallBackClassSelect} selected_position='0'></SelectClass>

          {this.state.LoadingStudent?<MyLoader/>:
            <div style={{marginTop: '12px'}}> 
            {this.state.mSpecialCaseStudent && this.state.mSpecialCaseStudent.length > 0 ? (
              this.state.mSpecialCaseStudent.map((item, index) => { 
                var mFeeDetails=[];
                mFeeDetails=item.fee_details;
                                           
                return(       
                <div key={index} style={{
                  marginBottom: '10px',
                  background: '#ffffff',
                  borderRadius: '8px',
                  boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  border: '2px solid #f0f0f0'
                }}>
                
                 <div style={{
                   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                   padding: '10px 14px',
                   color: '#ffffff'
                 }}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}> 
                  <div style={{
                    position: 'relative',
                    flexShrink: 0
                  }}>
                                <div style={{
                                  width: '55px',
                                  height: '55px',
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  border: '2px solid rgba(255,255,255,0.3)',
                                  background: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <img  
                                    src={item.student_img_path}  
                                    alt={item.stu_name}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover'
                                    }}
                                  />
                                </div>
                                <div style={{
                                  position: 'absolute',
                                  bottom: '-6px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  background: 'rgba(255,255,255,0.95)',
                                  padding: '1px 6px',
                                  borderRadius: '8px',
                                  fontSize: '9px',
                                  fontWeight: 600,
                                  color: '#374151',
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {item.student_enrollment_no}
                                </div>                
                  </div>
                  <div style={{flex: 1, minWidth: 0}}>
                    <h4 style={{
                      margin: '0 0 4px 0',
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#ffffff',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap'
                    }}> 
                      {item.stu_name} 
                    </h4>
                    <p style={{
                      margin: '0 0 4px 0',
                      fontSize: '12px',
                      color: 'rgba(255,255,255,0.9)',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap'
                    }}> 
                      Father: <span style={{fontWeight: 500}}>{item.father_name}</span> 
                    </p>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      flexWrap: 'wrap'
                    }}>
                      <div style={{
                        background: 'rgba(255,255,255,0.2)',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 500
                      }}>
                        {item.class[0].section_id==='No'?'Class '+item.class[0].class_name:'Class '+item.class[0].class_name+':'+item.class[0].section_name}
                      </div>
                      <div style={{
                        fontSize: '11px',
                        color: 'rgba(255,255,255,0.85)'
                      }}>
                        SRN: <span style={{fontWeight: 600}}>{item.sr_admission_no}</span>
                      </div>
                    </div>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.15)',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    minWidth: '60px'
                  }}>
                    <p style={{
                      margin: '0 0 4px 0',
                      fontSize: '9px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      opacity: 0.9
                    }}> 
                      Roll No. 
                    </p>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: '#ffffff',
                      color: '#667eea',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '14px',
                      fontWeight: 700,
                      boxShadow: '0 1px 4px rgba(0,0,0,0.15)'
                    }}>
                      {item.class[0].student_roll_no}
                    </div>
                  </div>
                 </div>
                 </div>
                 
                 <div style={{
                   padding: '12px',
                   background: '#ffffff',
                   marginTop: '10px'
                 }}>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '10px'
                  }}>
                 {mFeeDetails && mFeeDetails.map((item2, index2) => { 
                                           
                     return( 
                      <div 
                        key={index2}
                        style={{
                          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                          border: '2px solid #e5e7eb',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                          transition: 'all 0.3s ease',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.2)';
                          e.currentTarget.style.transform = 'translateY(-3px)';
                          e.currentTarget.style.borderColor = '#667eea';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.06)';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.borderColor = '#e5e7eb';
                        }}
                      >
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          width: '60px',
                          height: '60px',
                          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                          borderRadius: '0 10px 0 60px',
                          zIndex: 0
                        }}></div>
                        <div style={{position: 'relative', zIndex: 1}}>
                          <div style={{
                            color: '#374151',
                            fontSize: '15px',
                            fontWeight: 700,
                            marginBottom: '8px',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px'
                          }}>
                            <i className="fa fa-tag" style={{color: '#667eea', fontSize: '12px'}}></i>
                            {item2.fee_name}
                          </div>
                          <div style={{
                            background: '#f9fafb',
                            borderRadius: '6px',
                            padding: '8px',
                            marginBottom: '6px',
                            border: '1px solid #f0f0f0'
                          }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <span style={{
                                color: '#6b7280',
                                fontSize: '10px',
                                fontWeight: 500,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                                <i className="fa fa-circle" style={{fontSize: '5px', color: '#9ca3af'}}></i>
                                Class Fee
                              </span>
                              <span style={{
                                color: '#374151',
                                fontSize: '13px',
                                fontWeight: 700
                              }}>
                                ₹{item2.fee_value}
                              </span>
                            </div>
                          </div>
                          <div style={{
                            background: item2.special_case === 'Yes' 
                              ? 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)' 
                              : 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                            borderRadius: '6px',
                            padding: '8px',
                            border: item2.special_case === 'Yes' 
                              ? '1px solid #a7f3d0' 
                              : '1px solid #93c5fd'
                          }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <span style={{
                                color: item2.special_case === 'Yes' ? '#059669' : '#2563eb',
                                fontSize: '10px',
                                fontWeight: 700,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                              }}>
                                <i className="fa fa-star" style={{fontSize: '7px'}}></i>
                                {item2.special_case === 'Yes' ? 'Special Fee' : 'Student Fee'}
                              </span>
                              {(() => {
                                const isEditing = this.state.editingFee && 
                                  this.state.editingFee.student_id === item.student_id && 
                                  this.state.editingFee.fee_id === item2.fee_id;
                                
                                if (isEditing) {
                                  return (
                                    <input
                                      type="number"
                                      value={this.state.editedFeeValue === null || this.state.editedFeeValue === undefined ? '' : this.state.editedFeeValue}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || value === null) {
                                          this.setState({ editedFeeValue: '' });
                                        } else {
                                          const numValue = parseFloat(value);
                                          if (!isNaN(numValue) && numValue >= 0) {
                                            this.setState({ editedFeeValue: numValue });
                                          }
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          this.handleSaveFee(item, item2);
                                        } else if (e.key === 'Escape') {
                                          this.handleCancelEdit();
                                        }
                                      }}
                                      autoFocus
                                      style={{
                                        width: '80px',
                                        padding: '4px 6px',
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        color: item2.special_case === 'Yes' ? '#059669' : '#2563eb',
                                        border: '2px solid #f59e0b',
                                        borderRadius: '4px',
                                        background: '#ffffff',
                                        textAlign: 'center'
                                      }}
                                    />
                                  );
                                } else {
                                  return (
                                    <span style={{
                                      color: item2.special_case === 'Yes' ? '#059669' : '#2563eb',
                                      fontSize: '15px',
                                      fontWeight: 800
                                    }}>
                                      ₹{item2.student_fee || item2.special_value}
                                    </span>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                          
                          {/* Fee-wise Edit/Delete buttons */}
                          <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '6px',
                            marginTop: '8px'
                          }}>
                            {(() => {
                              const feeKey = `${item.student_id}_${item.class_id}_${item2.fee_id}`;
                              const feeCollected = this.state.feeCollectionStatus[feeKey];
                              const canEditDelete = feeCollected !== true;
                              const isEditing = this.state.editingFee && 
                                this.state.editingFee.student_id === item.student_id && 
                                this.state.editingFee.fee_id === item2.fee_id;
                              
                              if (isEditing) {
                                return (
                                  <>
                                    <button
                                      onClick={() => this.handleSaveFee(item, item2)}
                                      disabled={this.state.savingFee}
                                      style={{
                                        flex: 1,
                                        padding: '6px 10px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background: this.state.savingFee
                                          ? '#9ca3af'
                                          : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: this.state.savingFee ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        opacity: this.state.savingFee ? 0.7 : 1,
                                        boxShadow: this.state.savingFee ? 'none' : '0 2px 4px rgba(16, 185, 129, 0.3)'
                                      }}
                                      title="Save changes (Enter)"
                                    >
                                      {this.state.savingFee ? (
                                        <>
                                          <i className="fa fa-spinner fa-spin" style={{fontSize: '10px'}}></i>
                                          Saving...
                                        </>
                                      ) : (
                                        <>
                                          <i className="fa fa-check" style={{fontSize: '10px'}}></i>
                                          Save
                                        </>
                                      )}
                                    </button>
                                    <button
                                      onClick={this.handleCancelEdit}
                                      disabled={this.state.savingFee}
                                      style={{
                                        flex: 1,
                                        padding: '6px 10px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background: this.state.savingFee
                                          ? '#9ca3af'
                                          : 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: this.state.savingFee ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        opacity: this.state.savingFee ? 0.7 : 1,
                                        boxShadow: this.state.savingFee ? 'none' : '0 2px 4px rgba(107, 114, 128, 0.3)'
                                      }}
                                      title="Cancel editing (Esc)"
                                    >
                                      <i className="fa fa-times" style={{fontSize: '10px'}}></i>
                                      Cancel
                                    </button>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <button
                                      onClick={() => this.handleEdit(item, item2)}
                                      disabled={!canEditDelete}
                                      style={{
                                        flex: item2.special_case === 'Yes' ? 1 : 'none',
                                        width: item2.special_case === 'Yes' ? 'auto' : '100%',
                                        padding: '6px 10px',
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        background: canEditDelete 
                                          ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                                          : '#e5e7eb',
                                        color: canEditDelete ? '#ffffff' : '#9ca3af',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: canEditDelete ? 'pointer' : 'not-allowed',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        opacity: canEditDelete ? 1 : 0.6,
                                        boxShadow: canEditDelete ? '0 2px 4px rgba(102, 126, 234, 0.3)' : 'none'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (canEditDelete) {
                                          e.currentTarget.style.transform = 'translateY(-1px)';
                                          e.currentTarget.style.boxShadow = '0 4px 8px rgba(102, 126, 234, 0.4)';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (canEditDelete) {
                                          e.currentTarget.style.transform = 'translateY(0)';
                                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.3)';
                                        }
                                      }}
                                      title={feeCollected === true ? `Fee collection/settlement done for ${item2.fee_name} - Edit not applicable` : `Edit ${item2.fee_name}`}
                                    >
                                      <i className="fa fa-edit" style={{fontSize: '10px'}}></i>
                                      Edit
                                    </button>
                                    {item2.special_case === 'Yes' && (
                                      <button
                                        onClick={() => this.handleDelete(item, item2)}
                                        disabled={!canEditDelete}
                                        style={{
                                          flex: 1,
                                          padding: '6px 10px',
                                          fontSize: '10px',
                                          fontWeight: 600,
                                          background: canEditDelete 
                                            ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' 
                                            : '#e5e7eb',
                                          color: canEditDelete ? '#ffffff' : '#9ca3af',
                                          border: 'none',
                                          borderRadius: '6px',
                                          cursor: canEditDelete ? 'pointer' : 'not-allowed',
                                          transition: 'all 0.2s ease',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '6px',
                                          opacity: canEditDelete ? 1 : 0.6,
                                          boxShadow: canEditDelete ? '0 2px 4px rgba(239, 68, 68, 0.3)' : 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                          if (canEditDelete) {
                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(239, 68, 68, 0.4)';
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (canEditDelete) {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(239, 68, 68, 0.3)';
                                          }
                                        }}
                                        title={feeCollected === true ? `Fee collection/settlement done for ${item2.fee_name} - Delete not applicable` : `Delete ${item2.fee_name}`}
                                      >
                                        <i className="fa fa-trash" style={{fontSize: '10px'}}></i>
                                        Delete
                                      </button>
                                    )}
                                  </>
                                );
                              }
                            })()}
                          </div>
                        </div>
                       </div>
             
                        )
                    })}    
                  </div>
                </div>
               
                </div>                   
                )
            })
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                color: '#6b7280'
              }}>
                <i className="fa fa-users" style={{fontSize: '36px', marginBottom: '12px', opacity: 0.3}}></i>
                <p style={{fontSize: '14px', margin: 0}}>No special case students found</p>
                <p style={{fontSize: '12px', margin: '6px 0 0 0', opacity: 0.7}}>Select a class to view special case students</p>
              </div>
            )}
            </div>  
            }
              </div>
           }


            <div style={{
              marginTop: '16px',
              paddingTop: '16px',
              borderTop: '1px solid #f0f0f0'
            }}>
              <Link to="/AdminMain/SpecialCaseCreation" style={{textDecoration: 'none', display: 'block'}}>
                    <button style={{
                      width: '100%',
                      padding: '10px 20px',
                      fontSize: '14px',
                      fontWeight: 600,
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      boxShadow: '0 2px 8px rgba(102, 126, 234, 0.4)',
                      transition: 'all 0.3s ease',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-1px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.5)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.4)';
                    }}
                    > 
                      <i className="fa fa-plus-circle" style={{marginRight: '6px'}}></i>
                      Create Special Case
                    </button>
               </Link>   
              </div>        
             </div>
           </div>
             )
            }
          } />
      
                       
          <Route path='/AdminMain/SpecialCaseCreation'  component={SpecialCaseCreation} />                    
          </switch>       
         </Router>  
          )
      }
    } 
  }
